import { render } from "./sportSelector.vue?vue&type=template&id=3ed9eceb&scoped=true&ts=true"
import script from "./sportSelector.vue?vue&type=script&lang=ts"
export * from "./sportSelector.vue?vue&type=script&lang=ts"

import "./sportSelector.vue?vue&type=style&index=0&id=3ed9eceb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed9eceb"]])

export default __exports__